import { render, staticRenderFns } from "./SurveyCard.vue?vue&type=template&id=b9174c62&"
import script from "./SurveyCard.vue?vue&type=script&lang=js&"
export * from "./SurveyCard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCard.vue?vue&type=style&index=0&id=b9174c62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports